import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ContactForm from "./components/ContactForm";

const siteUrl = "https://teachmanga4.github.io";

const stats = [
  { value: "8年", label: "专注漫画阅读服务" },
  { value: "5000+", label: "海量漫画资源" },
  { value: "800万", label: "注册读者用户" },
  { value: "98%", label: "用户满意度" },
];

const milestones = [
  {
    year: "2018",
    title: "平台创立",
    desc: "178漫画网上线，专注提供《家庭教师》等经典漫画的在线免费阅读服务。",
  },
  {
    year: "2020",
    title: "下拉式阅读上线",
    desc: "全面升级阅读器，推出下拉式漫画阅读模式，解放读者双手，广受好评。",
  },
  {
    year: "2023",
    title: "全端适配",
    desc: "完成手机、平板、电脑全端适配优化，随时随地畅享高清阅读。",
  },
  {
    year: "2026",
    title: "全新升级",
    desc: "图源画质与更新速度全面升级，持续为读者带来更好的阅读体验。",
  },
];

const testimonials = [
  {
    name: "小林同学",
    role: "家庭教师十年老粉",
    avatar: "林",
    content: "从初中追《家庭教师》到现在，178漫画网的下拉式阅读真的太舒服了，一刷到底停不下来，画质也很清晰！",
    rating: 5,
  },
  {
    name: "阿泽",
    role: "漫画重度爱好者",
    avatar: "泽",
    content: "更新速度很快，页面干净没有烦人的广告，在手机上看体验非常好，已经推荐给身边好多朋友了。",
    rating: 5,
  },
  {
    name: "柚子茶",
    role: "上班族漫迷",
    avatar: "柚",
    content: "通勤路上用178漫画网看漫画很方便，不用下载App，点开就能看，下拉式阅读解放双手真的爱了。",
    rating: 5,
  },
  {
    name: "大熊",
    role: "学生党",
    avatar: "熊",
    content: "完全免费这点对学生党太友好了，分类清晰找漫画很快，家庭教师全集都能看，良心网站！",
    rating: 5,
  },
];

const contacts = [
  {
    icon: "ri-map-pin-2-line",
    title: "公司地址",
    lines: ["北京市朝阳区建国路88号", "现代城SOHO B座 12层"],
  },
  {
    icon: "ri-mail-line",
    title: "电子邮箱",
    lines: ["service@178mh.com", "商务合作：bd@178mh.com"],
  },
  {
    icon: "ri-phone-line",
    title: "联系电话",
    lines: ["010-8888-6666", "400-888-1786（客服热线）"],
  },
  {
    icon: "ri-time-line",
    title: "工作时间",
    lines: ["周一至周五 9:00 - 18:00", "周末及节假日在线值班"],
  },
];

export default function AboutPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="关于我们-178漫画网-品牌介绍与联系我们"
        description="了解178漫画网：专注漫画在线免费阅读服务的品牌，提供《家庭教师》等热门漫画的下拉式阅读体验。查看我们的品牌故事、读者口碑与联系方式。"
        keywords="关于我们,178漫画网,品牌介绍,联系我们,漫画阅读"
        canonical={`${siteUrl}/about`}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "178漫画网",
            url: siteUrl,
            logo: `${siteUrl}/logo.png`,
            description: "178漫画网是一家提供漫画在线免费阅读服务的平台，主打《家庭教师》等热门漫画的下拉式在线阅读。",
            address: {
              "@type": "PostalAddress",
              streetAddress: "建国路88号现代城SOHO B座12层",
              addressLocality: "北京市朝阳区",
              addressCountry: "CN",
            },
            email: "service@178mh.com",
            telephone: "400-888-1786",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
              { "@type": "ListItem", position: 2, name: "关于我们", item: `${siteUrl}/about` },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "关于我们-178漫画网",
            url: `${siteUrl}/about`,
            inLanguage: "zh-CN",
          },
        ]}
      />

      <Navbar />

      <main id="main-content" className="flex-1 pt-16 md:pt-[72px]">
        {/* Banner */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=stylized%20artistic%20illustration%20of%20a%20cozy%20modern%20reading%20space%20with%20floating%20manga%20books%20and%20comic%20pages%20in%20the%20air%2C%20warm%20orange%20and%20amber%20lighting%2C%20reading%20community%20theme%2C%20abstract%20artistic%20composition%2C%20soft%20bokeh%20particles%2C%20cinematic%20wide%20shot%2C%20no%20text%20no%20people&width=1600&height=900&seq=about-banner&orientation=landscape"
              alt="178漫画网品牌背景"
              title="关于178漫画网-漫画在线阅读平台"
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60" />
          </div>
          <div className="relative z-10 mx-auto w-full px-4 py-16 md:px-6 lg:px-10 md:py-24">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
            <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-5xl">关于我们</h1>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-background-50/90 md:text-base md:leading-8">
              178漫画网，一个热爱漫画的人聚在一起，打造的免费在线阅读平台。
              从《家庭教师》到更多热门佳作，我们用下拉式阅读，让看漫画这件事变得更简单、更快乐。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto grid w-full grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:px-6 lg:px-10">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1 text-center">
                <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</span>
                <span className="text-xs text-foreground-700 md:text-sm">{s.label}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Brand intro */}
        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20stylized%20illustration%20of%20a%20friendly%20community%20of%20diverse%20readers%20relaxing%20and%20reading%20comic%20books%20on%20cozy%20sofas%20in%20a%20modern%20library%2C%20anime%20flat%20art%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20plants%20and%20warm%20lights%2C%20clean%20composition%2C%20high%20quality%20illustration%2C%20no%20text&width=1200&height=800&seq=about-brand&orientation=landscape"
                  alt="178漫画网品牌介绍配图"
                  title="178漫画网-专注漫画在线免费阅读"
                  className="w-full rounded-lg object-cover"
                />
              </div>
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-building-2-line" aria-hidden="true" /> 品牌介绍
                </span>
                <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">关于178漫画网</h2>
                <div className="mt-4 flex flex-col gap-3 text-sm leading-7 text-foreground-800 md:text-base">
                  <p>
                    178漫画网创立于2018年，是一家专注于漫画在线阅读服务的互联网平台。我们始终相信，
                    <strong className="text-foreground-950">优质的漫画应该被更多人看到，轻松的阅读应该触手可及</strong>。
                  </p>
                  <p>
                    平台以《家庭教师》等经典热血漫画为特色，覆盖热血少年、校园青春、搞笑日常、动作冒险、
                    奇幻魔法、运动竞技、科幻机甲、悬疑推理八大分类，累计收录漫画资源超过5000部。
                  </p>
                  <p>
                    我们自主研发了<strong className="text-primary-600">下拉式漫画阅读</strong>模式，无需频繁翻页，向下滑动即可连续阅读，
                    彻底解放读者的双手。上线以来，已有超过800万读者通过178漫画网享受免费、流畅、高清的阅读体验。
                  </p>
                  <p>
                    未来，我们会继续深耕漫画阅读领域，引入更多优质内容，打磨阅读体验，
                    让178漫画网成为每一位漫画爱好者最爱的在线阅读伙伴。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
            <div className="mb-10 text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-road-map-line" aria-hidden="true" /> 发展历程
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">一路同行，共同成长</h2>
            </div>
            <ol className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {milestones.map((m, idx) => (
                <li key={m.year} className="relative flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-award-line" aria-hidden="true" />
                  </span>
                  <span className="mt-2 font-heading text-lg font-black text-primary-600">{m.year}</span>
                  <h3 className="text-sm font-bold text-foreground-950">{m.title}</h3>
                  <p className="text-xs leading-6 text-foreground-700">{m.desc}</p>
                  {idx < milestones.length - 1 && (
                    <span className="hidden lg:block absolute right-0 top-1/2 -mr-4 h-px w-8 bg-background-300" aria-hidden="true" />
                  )}
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* Reputation */}
        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
            <div className="mb-10 text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                <i className="ri-heart-3-fill" aria-hidden="true" /> 读者口碑
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">百万读者的真实评价</h2>
              <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
                <span className="font-heading text-3xl font-black text-foreground-950">4.9</span>
                <div className="flex items-center gap-0.5 text-accent-500">
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                  <i className="ri-star-fill" aria-hidden="true" />
                </div>
                <span className="text-sm text-foreground-700">基于 28.6万 条读者评价</span>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-5">
                  <div className="flex items-center gap-0.5 text-accent-500">
                    {Array.from({ length: t.rating }, (_, i) => (
                      <i key={i} className="ri-star-fill" aria-hidden="true" />
                    ))}
                  </div>
                  <blockquote className="text-sm leading-7 text-foreground-800">「{t.content}」</blockquote>
                  <figcaption className="mt-auto flex items-center gap-3 border-t border-background-200 pt-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                      {t.avatar}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-600">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
            <div className="mb-10 text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-customer-service-2-line" aria-hidden="true" /> 联系方式
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">联系我们</h2>
              <p className="mt-2 text-sm text-foreground-700">有任何建议、反馈或合作意向，欢迎随时与我们联系</p>
            </div>

            <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-1 xl:grid-cols-2">
                {contacts.map((c) => (
                  <div key={c.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500/10 text-primary-600">
                      <i className={`${c.icon} text-xl`} aria-hidden="true" />
                    </span>
                    <div>
                      <h3 className="text-sm font-bold text-foreground-950">{c.title}</h3>
                      {c.lines.map((line) => (
                        <p key={line} className="mt-1 text-xs leading-6 text-foreground-700">{line}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className="lg:col-span-3">
                <h3 className="mb-4 font-heading text-lg font-black text-foreground-950">在线留言</h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}